/**
 * @name setIfExists
 * @description
 * If the value exists as a property of the input, set it to the property of
 * the output. Used when formatting data being sent to the API.
 * Sometimes there's a data disparity between the app and the api.
 * modelAttribute is designed to fix this (patch, really).
 * If you use modelAttribute, this is the value that the api expects us to send.
 * @param {unknown} input Unknown
 * @param {unknown} attribute Unknown
 * @param {unknown} output Unknown
 * @param {unknown} modelAttribute Unknown
 * @return {boolean} Returns a boolean based on the evaluation
 */
export default function setIfExists(input, attribute, output, modelAttribute) {
  if (attribute in input) {
    output[modelAttribute ? modelAttribute : attribute] = input[attribute];
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./utils/set-if-exists.js